/**
 * @license @tabler/icons-react v3.10.0 - MIT
 *
 * This source code is licensed under the MIT license.
 * See the LICENSE file in the root directory of this source tree.
 */

import createReactComponent from '../createReactComponent.mjs';

var IconNavigationWest = createReactComponent("outline", "navigation-west", "IconNavigationWest", [["path", { "d": "M9 3l1 6l2 -3.75l2 3.75l1 -6", "key": "svg-0" }], ["path", { "d": "M16 21l-4 -8l-4 8l4 -2z", "key": "svg-1" }]]);

export { IconNavigationWest as default };
//# sourceMappingURL=IconNavigationWest.mjs.map
